import moment from 'moment';

export function parseGameListResults(rows, today = moment().startOf('day')) {
  const games = [];

  rows.forEach((row, rowIndex) => {
    const publishDateRaw = row.publishDate?.toString().trim();
    const publishDate = publishDateRaw ? moment(publishDateRaw, 'YYYY-MM-DD', true) : null;
    const date = row.date?.toString().trim() || 'Unknown date';
    const link = row.link?.toString().trim() || '';
    const name = row.name?.toString().trim() || 'Untitled';
    const type = row.type?.toString().trim() || 'game';

    const parsed = {
      date,
      link,
      name,
      type,
      publishDate,
      rowIndex,
    };

    const valid = publishDate && publishDate.isValid() && link && name;
    if (!valid) {
      console.warn('Skipping malformed game row', rowIndex, parsed);
      return;
    }

    games.push(parsed);
  });

  const sortedGames = games.sort((a, b) => a.publishDate.diff(b.publishDate));

  if (sortedGames.length === 0) {
    return {
      upcoming: [],
      error: 'No valid game rows found in the sheet.',
    };
  }

  let currentIndex = 0;
  for (let i = 0; i < sortedGames.length; i++) {
    if (sortedGames[i].publishDate.isSameOrBefore(today)) {
      currentIndex = i;
    } else {
      break;
    }
  }

  return {
    upcoming: sortedGames.slice(currentIndex, currentIndex + 4),
    error: null,
  };
}
